var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { store } from '@core';
import { AppRouter } from '@router';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'sonner';
export var App = function () {
    return (_jsx(BrowserRouter, { children: _jsxs(Provider, __assign({ store: store }, { children: [_jsx(AppRouter, {}), _jsx(Toaster, { richColors: true, closeButton: true, toastOptions: {
                        duration: 5000,
                    } })] })) }));
};
